import React from "react";
import PropTypes from "prop-types";

import { Form } from "..";

export function FormDate({
  id,
  name,
  description,
  value,
  required,
  errorMessage,
  disabled,
  yearRange,
}) {
  return (
    <Form.DatePicker
      name={id}
      label={name}
      description={description}
      initialDate={value}
      dataTest="form-date"
      placeholderText="e.g. 02/04/2022"
      dateFormat="MM/dd/yyyy"
      required={required}
      errorMessage={errorMessage}
      disabled={disabled}
      yearDropdownItemNumber={yearRange}
    />
  );
}

FormDate.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  yearRange: PropTypes.number,
};

FormDate.defaultProps = {
  description: "",
  value: null,
  required: true,
  errorMessage: "Please enter the date",
  disabled: false,
  yearRange: 120,
};

export default FormDate;
